/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationPipelineConfigShow } from '../../axios/organisationPipelineConfigShow'
import type {
	OrganisationPipelineConfigShowError,
	OrganisationPipelineConfigShowPathParams,
	OrganisationPipelineConfigShowResponse,
} from '../../types/OrganisationPipelineConfigShow'

export const organisationPipelineConfigShowQueryKey = (
	organisation: OrganisationPipelineConfigShowPathParams['organisation'],
) => [{ url: '/organisations/:organisation/pipeline-config', params: { organisation } }] as const

export type OrganisationPipelineConfigShowQueryKey = ReturnType<typeof organisationPipelineConfigShowQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::show */
export function organisationPipelineConfigShowQueryOptions(
	organisation: OrganisationPipelineConfigShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationPipelineConfigShowResponse,
		AxiosError<OrganisationPipelineConfigShowError>,
		OrganisationPipelineConfigShowResponse,
		OrganisationPipelineConfigShowQueryKey
	>({
		queryKey: organisationPipelineConfigShowQueryKey(organisation),
		queryFn: ({ signal }) =>
			organisationPipelineConfigShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::show */
export function useOrganisationPipelineConfigShow<TSelectData = OrganisationPipelineConfigShowResponse>(
	organisation: OrganisationPipelineConfigShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationPipelineConfigShowResponse,
					AxiosError<OrganisationPipelineConfigShowError>,
					TSelectData,
					OrganisationPipelineConfigShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationPipelineConfigShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationPipelineConfigShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::show */
export function useOrganisationPipelineConfigShowSuspense<TSelectData = OrganisationPipelineConfigShowResponse>(
	organisation: OrganisationPipelineConfigShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationPipelineConfigShowResponse,
					AxiosError<OrganisationPipelineConfigShowError>,
					TSelectData,
					OrganisationPipelineConfigShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationPipelineConfigShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationPipelineConfigShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
